import styled from 'styled-components';
import {transparentize} from 'polished';
import {TaskProgressType} from 'api/task/types';

export const Wrapper = styled.div`
  padding: 30px;
  margin: 20px 0;
  box-sizing: border-box;
  text-align: center;
  border-radius: 5px;
  border: 1px solid ${({theme}) => `
    ${theme.variables.borderColor};
  `};
`;

export const Total = styled.strong`
  display: block;
  margin-bottom: 10px;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
`;

export const Result = styled.span<{
  type: TaskProgressType;
}>`
  display: block;
  margin-bottom: 10px;
  color: ${({theme, type}) => (
    type === TaskProgressType.Success
  ) ? theme.colors.green : theme.colors.red};
`;

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Item = styled.li`
  margin: 6px 0;
  line-height: 16px;
  font-size: 12px;
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};
  
  span {
    margin-left: 2px;
    color: ${({theme}) => `
      ${transparentize(.2, theme.variables.color)};
    `};
  }
`;
